<template>
  <div class="goods-detail-wrapper">
    <iframe :src="webUrl" frameborder="0" class="content-iframe"></iframe>
    <div v-if="goodsInfo" class="btm-wrapper">
      <van-button @click="actionForHome" class="btn lf-btn" icon="wap-home-o" type="primary">首页</van-button>
      <van-button :disabled="goodsInfo.originPrice == 0" @click="actionForMiddleBtn" class="btn rg-btn" :class="{'selBg': goodsInfo.priceType == 1}" type="default">
        <p class="down-title">{{goodsInfo.originPriceTitle}}</p>
        <p class="up-title" v-if="goodsInfo.originPrice != 0"> {{`¥${goodsInfo.originPrice * 0.01}`}}</p>
      </van-button>
      <van-button :disabled="goodsInfo.groupPrice == 0" @click="actionForRgBtn" class="btn rg-btn" :class="{'selBg': goodsInfo.priceType == 2}" type="default">
        <p class="down-title">原价</p>
        <p class="up-desc"> {{goodsInfo.groupPriceTitle}} </p>
      </van-button>
    </div>
  </div>
</template>

<script>
  import {groupBuyGoodsInfo, weixincreate} from "@/api/groupbuy";
  import {wxpay} from "@/lib/wxShare";

  export default {
    data(){
      return{
        goodsInfo: null,
        webUrl: location.origin + '/h5/introduce/'
      }
    },

    created() {
      //加载商品信息
      this.request_groupBuyGoodsInfo()
    },

    activated() {
      //加载商品信息
      this.request_groupBuyGoodsInfo()
    },
    methods: {
      //点击回到首页
      actionForHome() {
        // window.location.replace(window.origin)
        this.$router.replace({ path: "/home", query: { entry: 'pay_page'} });


        // this.$router.back(-1);
      },

      //点击中间按钮
      actionForMiddleBtn() {
        this.request_weixincreate('originPrice')
      },

      //点击右侧按钮
      actionForRgBtn() {
        this.request_weixincreate('groupPrice')
      },

      //========net==========
      //下单
      request_weixincreate(tag) {
        let params = {}
        if (tag == 'originPrice'){//原价
          params = {
            groupBuyGoodsId: this.goodsInfo.groupBuyGoodsId,
            priceType: 1,
          }
        }else {//团购
          params = {
            groupBuyGoodsId: this.goodsInfo.groupBuyGoodsId,
            priceType: 2,
          }
        }
        if (this.$route.query.childUserId){
          params['childUserId'] = this.$route.query.childUserId
        }

        this.$loading.show()
        weixincreate(params).then(res => {
          this.$loading.hide()
          if (res.code == 0){
            let params = res.data;
            wxpay(params, this._paySuccessBlock)
          }else {
            this.$toast({
              message: res.msg,
              duration: 1000
            })
          }
        }).catch(err => {
          this.$loading.hide()
        })
      },

      //加载商品信息
      request_groupBuyGoodsInfo(){
        const groupBuyGoodsId = this.$route.query.groupBuyGoodsId;
        const priceType = this.$route.query.priceType;
        let params = {
          groupBuyGoodsId,
          priceType
        }
        this.$loading.show()
        groupBuyGoodsInfo(params).then(res => {
          this.$loading.hide()
          if (res.code == 0){
            this.goodsInfo = res.data;
          }else {
            this.$toast({
              message: res.msg,
              duration: 1000
            })
          }
        })
      },

      //微信支付的回调
      _paySuccessBlock(payResult) {
        //判断是否是微信
        let ua = navigator.userAgent.toLowerCase();
        let isWeixin = ua.match(/MicroMessenger/i) == "micromessenger" ? true : false;
        if (isWeixin) {
          if (payResult.err_msg == "get_brand_wcpay_request:ok") {//支付成功
            // this.$router.push({
            //   path: '/paySuccess',
            //   query: {
            //     orderId: this.orderId,
            //   }
            // })
            this.$toast('恭喜您购买成功');
          } else {//支付失败
            this.$toast({
              message: '未支付或支付失败',
              duration: 1000
            })
          }
        }
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import "../stylesheet/common.styl"
  .goods-detail-wrapper {
    box-sizing: border-box;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }
  .content-iframe{
    width: 100%;
    flex: 1;
    margin-bottom: 1.33333rem;
  }
  .btm-wrapper{
    position: fixed;
    bottom:  env(safe-area-inset-bottom);
    left: 0;
    width: 100vw;
    height: 50px;
    display: flex;
    background-color: #F7F7F7;
    .btn{
      background-color: #F7F7F7;
      border: none;
    }
    .lf-btn{
      color: #000;
      border-right: 1px solid #F7F7F7;
    }
    .rg-btn{
      flex: 1;
      border-right: 1px solid #F7F7F7;
    }
    .selBg{
      color: #fff;
      background-color: $common-blue;
    }
    .up-title{
      font-size: 18PX;
    }
    .up-desc{
      font-size: 18PX;
      text-decoration: line-through;
    }
  }
</style>



// WEBPACK FOOTER //
// app/pages/pay/PayPage.vue